import { Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { OnboardingFunnelBanner } from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelBanner/OnboardingFunnelBanner';
import { useOnboardingFunnel } from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelWrapper/hooks/useOnboardingFunnel';

export interface OnboardingFunnelWrapperProps {
  corpId: string;
}

export function OnboardingFunnelWrapper({
  corpId,
}: OnboardingFunnelWrapperProps): JSX.Element | null {
  const { showBanner, bannerCopy, href } = useOnboardingFunnel(corpId);

  if (!showBanner) {
    return null;
  }

  return (
    <Stack y="md">
      <OnboardingFunnelBanner
        headerText={bannerCopy.headerText}
        bodyText={bannerCopy.bodyText}
        buttonText={bannerCopy.buttonText}
        href={href}
      />
    </Stack>
  );
}
